import { combineReducers } from "redux";

import AuthReducer from "./auth-reducer";
import BalanceReducer from "./balance-reducer";
import ConfigReducer from "./config-reducer";

const appReducer = combineReducers({
    authReducer: AuthReducer,
    balanceReducer: BalanceReducer,
    configReducer: ConfigReducer
});

const rootReducer = (state, action) => {
    if (action.type === "LOGOUT") {
        state = undefined;
    }
    return appReducer(state, action);
}

export default rootReducer;
